export function getForm(wfConfig, formId) {
  var _wfConfig$formsById;
  return (_wfConfig$formsById = wfConfig.formsById) == null ? void 0 : _wfConfig$formsById[formId];
}
//# sourceMappingURL=controller-props.js.map